module.exports = __webpack_public_path__ + "img/back-arrow.8ae98452.svg";